import { Environment } from '@thiememeulenhoff/types';

export interface SecurityConfig {
  environment: Environment;
  clientId: string;
  clientSecret: string;
  interceptorUrlWhitelist?: Array<string>;
  debug?: boolean;
  enableInterceptor?: boolean;
  enableCallback?: boolean;
  callbackPath?: string;
  useUserCookie?: boolean;
}

export const PLATFORM_TOKEN = 'platform_token';

export const USE_WEBAPP_PLATFORM_TOKEN = 'useWebappPlatformToken';
